/**
 * Version of docs/mealmap/privacy-policy.html (served as /privacy.html) that
 * sign-up consent refers to. Bump together with the policy's effective date.
 */
export const PRIVACY_POLICY_VERSION = "2026-10-11";
export const PRIVACY_POLICY_PATH = "/privacy.html";
export const SIGNUP_CONSENT_LABEL = "I've read the privacy policy and agree that Abbi's Way can use my answers, including health information, to coach me.";
export function buildSignupConsent(platform, now = new Date()) {
    return {
        privacyVersion: PRIVACY_POLICY_VERSION,
        acceptedAt: now.toISOString(),
        platform,
    };
}
